export default __webpack_public_path__ + "static/media/logo.618bf669.svg";